import { render, staticRenderFns } from "./AddClinicDialog.vue?vue&type=template&id=11bc0770"
import script from "./AddClinicDialog.vue?vue&type=script&lang=js"
export * from "./AddClinicDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports